export const STEP_1 = 0;
export const STEP_2 = 1;

export const buttonHash = {
  'All': 'all',
  'Last 3': 3,
  'Last 6': 6,
  'Last 12': 12,
};
